export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVQI12PIz8AAAAADAAE2KDOfAAAAAElFTkSuQmCC"